import { z } from 'zod';
import { c } from '../../contract';

const promotionalOfferSchema = z.object({
  id: z.string(),
  userId: z.string(),
  promoId: z.string(),
  productId: z.string(),
  isActive: z.boolean(),
  isUsed: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type PromotionalOffer = z.infer<typeof promotionalOfferSchema>;

export const promotionalOfferRouter = c.router(
  {
    createOrGetOffer: {
      summary: 'Create or get a promotional offer for the authenticated user (migrated from Jupiter, DEV-4476)',
      method: 'POST',
      path: '/create-or-get-offer',
      body: z.object({
        promoId: z.string(),
        productId: z.string(),
      }),
      responses: {
        200: z.object({ offer: promotionalOfferSchema }),
        // Offer is not active anymore / has already been used (parity with legacy Jupiter 400).
        400: z.object({ error: z.string() }),
      },
    },
    onSubscriptionPurchase: {
      summary: 'Mark a promotional offer as used after a subscription purchase (migrated from Jupiter, DEV-4476)',
      method: 'PUT',
      path: '/on-subscription-purchase',
      body: z.object({
        promoId: z.string(),
        productId: z.string(),
      }),
      responses: {
        200: z.object({ success: z.literal(true) }),
      },
    },
  },
  {
    pathPrefix: '/promotional-offer',
  },
);
